package com.upcominds.expedite.model

import kotlinx.serialization.Serializable
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant

@Serializable
data class Quiz(
    val id: String,
    val challengeId: String,
    val title: String,
    val description: String,
    val questions: List<QuizQuestion>
)

@Serializable
data class QuizQuestion(
    val id: String,
    val text: String,
    val position: Int,
    val options: List<QuizOption>,
    val correctOptionId: String
)

@Serializable
data class QuizOption(
    val id: String,
    val text: String,
)

// Runtime (non-serializable) result models
data class QuizResult(
    val totalQuestions: Int,
    val correctAnswers: Int,
    val elapsedSeconds: Int,
    val score: Int,
    val pointsAwarded: Int
)

// Timing helper
internal data class QuizTimer(
    val start: Instant? = null,
    val end: Instant? = null,
) {
    fun startTimer(): QuizTimer = copy(start = Clock.System.now(), end = null)
    fun stopTimer(): QuizTimer = copy(end = Clock.System.now())
    val elapsedSeconds: Int
        get() = if (start != null && end != null) (end.epochSeconds - start.epochSeconds).toInt() else 0
}
